import React from 'react';
import { styled, keyframes } from '@mui/material/styles';

const fade = keyframes`
  from { opacity: 1; }
  to { opacity: 0.2; }
`;

const SpinnerContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '100%',
});

// The actual native-style blade container
const AppleStyleLoader = styled('div')({
  position: 'relative',
  width: '24px',
  height: '24px',
  display: 'inline-block',
  '& div': {
    position: 'absolute',
    width: '2px', // Blade thickness
    height: '6px', // Blade length
    background: '#8e8e93', // Native gray (or use #1d9bf0 for X blue)
    borderRadius: '1px',
    left: '11px',
    top: '0',
    transformOrigin: 'center 12px',
    animation: `${fade} 1s linear infinite`,
  },
  // Generate 12 blades with staggered delays
  ...Array.from({ length: 12 }).reduce((acc, _, i) => {
    acc[`& div:nth-of-type(${i + 1})`] = {
      transform: `rotate(${i * 30}deg)`,
      animationDelay: `${i * 0.083 - 1}s`,
    };
    return acc;
  }, {}),
});

const LoadingSpinner = ({ marginTop = '0px', color }) => {
  return (
    <SpinnerContainer style={{ marginTop }}>
      <AppleStyleLoader>
        {/* 12 Blades for the native look */}
        {[...Array(12)].map((_, i) => (
          <div key={i} style={color ? { background: color } : {}} />
        ))}
      </AppleStyleLoader>
    </SpinnerContainer>
  );
};

export default LoadingSpinner;
